// assets/infinite-scroll.js
document.addEventListener('DOMContentLoaded', () => {
  const container  = document.getElementById('ProductGridContainer');
  if (!container) return;

  const grid       = document.getElementById('product-grid');
  const totalPages = parseInt(container.dataset.totalPages, 10);
  const loader     = document.getElementById('InfiniteScrollLoader');

  let nextPage = 2;
  let loading  = false;
  let lastRun  = 0;

  function throttle(fn, delay = 300) {
    return function (...args) {
      const now = Date.now();
      if (now - lastRun > delay) {
        fn.apply(this, args);
        lastRun = now;
      }
    };
  }

  function showLoader() {
    if (!loader) return;
    loader.classList.add('infinite-scroll-loader-visible');
    loader.setAttribute('aria-hidden', 'false');
  }

  function hideLoader() {
    if (!loader) return;
    loader.classList.remove('infinite-scroll-loader-visible');
    loader.setAttribute('aria-hidden', 'true');
  }

  function loadNextPage() {
    // stop if already loading or no more pages
    if (loading || (Number.isFinite(totalPages) && nextPage > totalPages)) return;

    loading = true;
    showLoader();

    const searchParam = new URLSearchParams(window.location.search);
    searchParam.set('page', nextPage);
    searchParam.set('view', 'infinite-products');

    const url = `${window.location.pathname}?${searchParam.toString()}`;

    fetch(url)
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;

        const items = tmp.querySelectorAll('#product-grid li');
        items.forEach(li => grid.appendChild(li));

        nextPage++;

        // if we passed the last page, remove scroll listener + hide loader
        if (Number.isFinite(totalPages) && nextPage > totalPages) {
          hideLoader();
          window.removeEventListener('scroll', onScrollThrottled);
        }
      })
      .catch(console.error)
      .finally(() => {
        loading = false;
        // Only hide if there are more pages to potentially load
        if (!Number.isFinite(totalPages) || nextPage <= totalPages) {
          hideLoader();
        }
      });
  }

  function onScroll() {
    const triggerPoint =
      container.offsetTop +
      container.offsetHeight -
      window.innerHeight -
      200;

    if (window.scrollY > triggerPoint) {
      loadNextPage();
    }
  }

  const onScrollThrottled = throttle(onScroll, 300);
  window.addEventListener('scroll', onScrollThrottled);
});
